import React from 'react';
import {Link} from "react-router-dom";
import { services } from '../../data/companyData';

const Nav = () => {
    return (
        <div className="main-menu text-center">
            <nav>
                <ul className="main-menu__list">
                    <li className="current">
                        <Link to={process.env.PUBLIC_URL + `/`}>Home</Link>
                    </li>
                    <li>
                        <Link to={process.env.PUBLIC_URL + `/about`}>About</Link>
                    </li>
                    <li className="dropdown">
                        <Link to={process.env.PUBLIC_URL + `/services`}>Services</Link>
                        <ul>
                            {services.map((service) => (
                                <li key={service.slug}>
                                    <Link to={process.env.PUBLIC_URL + service.path}>{service.title}</Link>
                                </li>
                            ))}
                        </ul>
                    </li>
                    <li>
                        <Link to={process.env.PUBLIC_URL + `/gallery`}>Gallery</Link>
                    </li>
                    <li><Link to={process.env.PUBLIC_URL + `/contact`}>Contact Us</Link></li>
                </ul>
            </nav>
        </div>
    )
}

export default Nav;


